import { render } from "./AgencyInfluencerCompare.vue?vue&type=template&id=2b46bee8"
import script from "./AgencyInfluencerCompare.vue?vue&type=script&lang=js"
export * from "./AgencyInfluencerCompare.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__